import type { TCsvType } from 'App/data-export/components/_utils/createAndDownloadCsvIfApplicable/createCsv'
import { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'

export const mapCsvTypeToRenderer: Record<TCsvType, (valueType: string) => unknown> = {
  // @ts-expect-error
  blocks: (valueType) => valueTypeRenderers[valueType]?.block,
  // @ts-expect-error
  irrigationZones: (valueType) => valueTypeRenderers[valueType]?.irrigationZone,
  // @ts-expect-error
  points: (valueType) => valueTypeRenderers[valueType]?.point,
}
